/**
 * Reduz à array a uma array de pares.
 * Os pares são realizados do item N com o item N + 1.
 * Esta estrategia é utilizada para manter a ordem dos elementos da array.
 *
 * @param array array que será reduzida a uma array de pares
 * @param shouldPair callback cujo objetivo é verificar se o elemento
 * em processamento da array deve ou não ser agrupado com o proximo elemento.
 */
export function conditionallyPair(array, shouldPair) {
  if (array.length === 0) {
    return array;
  }

  if (array.length === 1) {
    return [array];
  }

  let first = true;
  return array.reduce((reduced, next) => {
    let shouldPairCurrent;
    const shouldPairNext = shouldPair(next);

    if (first) {
      first = false;
      shouldPairCurrent = shouldPair(reduced);
      if (shouldPairCurrent && shouldPairNext) {
        return [[reduced, next]];
      }
      return [[reduced], [next]];
    }

    const lastGroup = reduced[reduced.length - 1];
    if (lastGroup.length > 1) {
      return [...reduced, [next]];
    }

    const lastGroupIntegrant = lastGroup[0];
    shouldPairCurrent = shouldPair(lastGroupIntegrant);
    if (shouldPairCurrent && shouldPairNext) {
      lastGroup.push(next);
      return reduced;
    }

    return [...reduced, [next]];
  });
}
